/**
 * Fælles åbnings- og lukkedagslogik (ITG-1324).
 * Bruges af både leveringsbeskeden på produktsider og Åben/Lukket i toplinjen,
 * så en helligdag aldrig kan slå igennem ét sted men ikke det andet.
 */
(() => {
  const TZ = 'Europe/Copenhagen';

  /** Butikkens kalenderdato og klokkeslæt — ikke browserens. */
  const nu = () => {
    const p = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const f = (t) => (p.find((x) => x.type === t) || {}).value;
    return {
      iso: `${f('year')}-${f('month')}-${f('day')}`,
      minutter: parseInt(f('hour'), 10) * 60 + parseInt(f('minute'), 10),
    };
  };

  /** Accepterer "24-12" (hvert år) og "2026-04-02" (bestemt dato), adskilt af linjeskift eller komma. */
  const parseLukkedage = (raw) => {
    const sæt = new Set();
    (raw || '')
      .split(/[\n,;]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((s) => sæt.add(s));
    return sæt;
  };

  /** Ren datoregning uden tidszoneskred: bygger videre på butikkens kalenderdato. */
  const datoOm = (isoStart, dage) => {
    const [y, m, d] = isoStart.split('-').map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    dt.setUTCDate(dt.getUTCDate() + dage);
    const iso = dt.toISOString().slice(0, 10);
    return { iso, ugedag: dt.getUTCDay(), ddmm: iso.slice(8, 10) + '-' + iso.slice(5, 7) };
  };

  const erLukket = (dag, åbneDage, lukkedage) =>
    !åbneDage.includes(dag.ugedag) || lukkedage.has(dag.iso) || lukkedage.has(dag.ddmm);

  /**
   * Første åbne dag fra og med `fraOffset` dage frem.
   * Går dag for dag, så både weekend og en helligdagsstime springes korrekt over.
   */
  const næsteÅbne = (isoStart, fraOffset, åbneDage, lukkedage) => {
    for (let i = fraOffset; i < fraOffset + 21; i++) {
      const dag = datoOm(isoStart, i);
      if (!erLukket(dag, åbneDage, lukkedage)) return { ...dag, om: i };
    }
    return null;
  };

  window.IBAabning = { nu, parseLukkedage, datoOm, erLukket, næsteÅbne };

  /* ---- Leveringsbesked: samme element-kontrakt på produktside og i kurv ---- */
  const NAVN = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  const opdaterLevering = (el) => {
    const cutoff = +el.dataset.hour * 60 + +el.dataset.minute;
    const { iso, minutter } = nu();
    const åbne = (el.dataset.openDays || '1,2,3,4,5').split(',').map((x) => parseInt(x, 10));
    const lukkedage = parseLukkedage(el.dataset.closedDates);
    const iDagÅben = !erLukket(datoOm(iso, 0), åbne, lukkedage);

    let html;
    if (iDagÅben && minutter < cutoff) {
      const m = cutoff - minutter, t = Math.floor(m / 60), r = m % 60;
      const rest = t > 0 ? t + ' t. ' + r + ' min.' : r + ' min.';
      html = (el.dataset.today || '')
        .replace(/\{time\}/g, '<strong>' + el.dataset.label + '</strong>')
        .replace(/\{countdown\}/g, rest);
    } else {
      const n = næsteÅbne(iso, 1, åbne, lukkedage);
      const navn = !n ? '' : n.om === 1 ? 'i morgen' : NAVN[n.ugedag];
      html = (el.dataset.next || '').replace(/\{day\}/g, '<strong>' + navn + '</strong>');
    }
    if (el.innerHTML !== html) el.innerHTML = html;
  };

  const kør = () => document.querySelectorAll('[data-usp-cutoff]').forEach(opdaterLevering);
  window.IBAabning.opdaterLevering = kør;

  kør();
  setInterval(kør, 30000);
  document.addEventListener('shopify:section:load', kør);
  // Kurven rendres om ved hver ændring, så beskeden skal gendannes bagefter
  document.addEventListener('cart:update', kør);
  document.addEventListener('cart:refresh', kør);
  // Temaet opdaterer kurven med morph, som muterer eksisterende noder frem for
  // at tilføje nye — derfor kan vi ikke stole på addedNodes. Vi reagerer i stedet
  // på at der findes en endnu ikke udfyldt besked.
  new MutationObserver(() => {
    if (document.querySelector('[data-usp-cutoff]:empty')) kør();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
